import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Historico } from "./components/Historico";
import "./styles/HistoricoInventarios.css";
import { getNombreAcopio } from "../../../../../../utility/utils";

class HistoricoInventarios extends Component {
    navigateToCreacion = (inventarioId) => {
        this.props.history.push(`/inventarios-almacen/almacenes/${inventarioId}`);
    };

    navigateToInventarioInicial = () => {
        this.props.history.push(
            `/inventarios-almacen/inventario-inicial?regresar=true`,
        );
    };

    render() {
        const { user } = this.props;
        const nombreAcopio = getNombreAcopio(user);

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="HISTÓRICO DE INVENTARIO DE MATERIA PRIMA EN ALMACENES"
                    subtitulo=""
                    noBorder
                >
                    <Historico
                        storageKey="historico_inventarios_state"
                        navigateToCreacion={this.navigateToCreacion}
                        navigateToInventarioInicial={
                            this.navigateToInventarioInicial
                        }
                        nombreAcopio={nombreAcopio}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(HistoricoInventarios);
